<template>
  <form-wrapper
    :inline="inline"
    :label-classes="labelClasses"
    :label="getWrapperlabel"
    :error="error"
    :required="required"
  >
    <div class="checkbox" :class="getFieldClasses">
      <input type="checkbox" :required="required" :id="getId" :name="name" v-model="model" :disabled="disabled" />
      <label class="checkbox-label" :for="getId">
        <span :data-label="getLabel">
          <div class="flex items-center justify-between h-full">
            <p
              :class="{ 'opacity-100' : model }"
              class="text-button-2 opacity-0 transition duration-300 font-bold font-title uppercase text-white pl-4
            ">
              {{ uncheckedLabel }}
            </p>
            <p
              :class="{ 'opacity-100' : !model }"
              class="text-button-2 opacity-0 transition duration-300 font-bold font-title uppercase text-white pr-4
            ">
              {{ checkedLabel }}
            </p>
          </div>
        </span>
        <slot>
          <!-- <p v-if="getLabel" v-html="getLabel" /> -->
        </slot>
      </label>
    </div>
    <template #label><slot name="label"></slot></template>
  </form-wrapper>
</template>

<script>
import FormWrapper from "./FormWrapper";

export default {
  components: {
    FormWrapper
  },
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    checked: Boolean,
    label: String,
    labelClasses: [String, Array],
    checkedLabel: String,
    uncheckedLabel: String,
    name: String,
    error: [String, Array],
    switch: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getFieldClasses() {
      return {
        "is-switch": this.switch,
        "text-danger": this.error,
        "is-disabled": this.disabled
      };
    },
    getId() {
      return this.name ? `${this.name}-${this._uid}` : this._uid;
    },
    getLabel() {
      if (this.checked) {
        return this.checkedLabel ? this.checkedLabel : this.label;
      } else {
        return this.uncheckedLabel ? this.uncheckedLabel : this.checkedLabel ? this.checkedLabel : this.label;
      }
    },
    getWrapperlabel() {
      return this.checkedLabel || this.uncheckedLabel ? this.label : ''
    },
    model: {
      get() {
        return this.checked;
      },
      set(value) {
        this.$emit("change", value);
      }
    }
  }
};
</script>
